/**
 * V2 Roller Section Configuration
 *
 * Maps V2 StepNode.content.roller paths for the WheelPicker screen type.
 *
 * V2 RollerConfig:
 * - dataType: FieldType
 * - separator: string
 * - wheels: Array<RollerWheel>
 * - appearance: RollerStyle
 * - labelAppearance: TypographyStyle
 *
 * Sprint: schema-v2-migration, Sprint 4
 */

export const V2_DATA_TYPE_OPTIONS = [
  { value: 'string', label: 'String' },
  { value: 'int', label: 'Integer' },
];

export const V2_WHEEL_KIND_OPTIONS = [
  { value: 'list', label: 'List' },
  { value: 'range', label: 'Range' },
];

export const MAX_WHEELS = 5;
export const MAX_WHEELS_INT = 1;
export const MAX_OPTIONS = 20;

/**
 * Default wheel structure for V2
 */
export function createDefaultV2Wheel(locale: string) {
  return {
    kind: 'list',
    options: { localizedOptions: { [locale]: ['Option 1', 'Option 2'] } },
    defaultValue: { [locale]: '' },
  };
}
